import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import Progress from 'react-progressbar';
import { useTranslation } from 'react-i18next';
import * as todoAction from './store/Indicator.action';
import { checkArray, Page_Size, shortenStringWithTooltip, hideImage, showBigImage, RightsAccess } from '../../../../Components/helper';
import noImage from '../../../../assets/images/no-image.png';
import '../Todo.css';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { useProductLandingPath } from '../../../../Components/CustomHooks/useProductLandingPath';

function List({ loading, mappedArray }) {
  const { t } = useTranslation('common');
  const productLandingPath = useProductLandingPath();

  const [state, setState] = useState({
    indicatorList: [],
    deleteId: null,
    hasMore: true,
    loading: false,
    selectedIdsArray: [],
    isSelectAll: false,
    openCloseTrackingModal: false,
    sampleEditData: null,
    dateData: [],
    saveParams: {
      poOrderId: '',
      popupType: '',
    },
    selectedColumn: [],
  });
  const { indicatorList, selectedColumn, selectedIdsArray, isSelectAll } = state;
  const { customModuleRight, TestingRight } = RightsAccess();

  useEffect(() => {
    const dat = mappedArray.sort((a, b) => a.value - b.value);
    setState((prev) => ({
      ...prev,
      selectedColumn: dat,
    }));
  }, [mappedArray]);
  const {
    IndicatorTodoListData: {
      indicatorListData,
      indicatorFilterValues: {
        searchText,
        selected_Season,
        selected_Year,
        selected_Month,
        selected_Brand,
        selected_SubBrand,
        selected_Supplier,
        selectedProductType,
        selected_Category1,
        selected_Category2,
        selected_Category3,
        selected_Category4,
        selected_CreatedBy,
        selected_ModifiedBy,
        selected_Status,
        selectedLicensor,
        selectedLicense,
        selectedLikeness,
        sortOrder,
        sortPropertyName,
      },
    },
    Users: { moduleAccess },
  } = useSelector((reduxState) => reduxState);

  const dispatch = useDispatch();

  useEffect(() => {
    if (Array.isArray(indicatorListData)) {
      setState((prevState) => ({
        ...prevState,
        indicatorList: indicatorListData,
      }));
    }
  }, [indicatorListData]);

  const headerSortingIcon = (lable, propertyName) => {
    return (
      <span className="cursor-pointer text-dark text-decoration-none">
        {lable}
        {sortPropertyName === propertyName ? (
          <>
            {sortOrder === '' && <i className="fa fa fa-sort ml-1" />}
            {sortOrder === 'Asc' && <i className="fa fa fa-sort-up ml-1" />}
            {sortOrder === 'Desc' && <i className="fa fa fa-sort-desc ml-1" />}
          </>
        ) : (
          <i className="fa fa fa-sort ml-1" />
        )}
      </span>
    );
  };

  const onSortColumn = async (propertyName) => {
    if (sortOrder === '' || sortOrder === 'Desc') {
      const sortObj = {
        seasons: selected_Season,
        year: selected_Year,
        month: selected_Month,
        brand: selected_Brand,
        subBrand: selected_SubBrand,
        supplier: selected_Supplier,
        productTypeId: selectedProductType,
        category1: selected_Category1,
        category2: selected_Category2,
        category3: selected_Category3,
        category4: selected_Category4,
        createdBy: selected_CreatedBy,
        modifiedBy: selected_ModifiedBy,
        status: selected_Status,
        licensorId: selectedLicensor,
        licenseId: selectedLicense,
        likenessId: selectedLikeness,
        type: 'progress-indicator',
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
        searchText,
        pageIndex: 1,
        pageSize: Page_Size,
      };
      const obj = {
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
      };
      await dispatch(todoAction.filterSortData(obj));
      await dispatch(todoAction.getIndicatorList(sortObj));
    } else {
      const sortObj = {
        sortOrder: 'Desc',
        seasons: selected_Season,
        year: selected_Year,
        month: selected_Month,
        brand: selected_Brand,
        subBrand: selected_SubBrand,
        supplier: selected_Supplier,
        productTypeId: selectedProductType,
        category1: selected_Category1,
        category2: selected_Category2,
        category3: selected_Category3,
        category4: selected_Category4,
        createdBy: selected_CreatedBy,
        modifiedBy: selected_ModifiedBy,
        licensorId: selectedLicensor,
        licenseId: selectedLicense,
        likenessId: selectedLikeness,
        type: 'progress-indicator',
        sortPropertyName: propertyName,
        searchText,
        pageIndex: 1,
        pageSize: Page_Size,
        status: selected_Status,
      };
      await dispatch(todoAction.getIndicatorList(sortObj));
      const obj = {
        sortOrder: 'Desc',
        sortPropertyName: propertyName,
      };
      await dispatch(todoAction.filterSortData(obj));
    }
  };

  const progressName = [
    { name: 'Design Details', id: 'design', moduleName: 'design' },
    { name: 'BOM', id: 'bom', moduleName: 'bom' },
    { name: 'Measurements', id: 'measurement', moduleName: 'measurement' },
    { name: 'Care Label', id: 'care', moduleName: 'care' },
    { name: 'Samples', id: 'samples', moduleName: 'samples' },
    { name: 'Cost', id: 'costing', moduleName: 'costing' },
    { name: 'Purchase Order', id: 'po', moduleName: 'po' },
  ];

  const staticprogressName = [
    { name: 'Design Details', id: 'design', moduleName: 'design' },
    { name: 'BOM', id: 'bom', moduleName: 'bom' },
    { name: 'Care Label', id: 'care', moduleName: 'care' },
    { name: 'Samples', id: 'samples', moduleName: 'samples' },
    { name: 'Cost', id: 'costing', moduleName: 'costing' },
    { name: 'Purchase Order', id: 'po', moduleName: 'po' },
  ];

  const colourCode = {
    red: '#f65158',
    grey: '#777777',
    yellow: '#fbb755',
    green: '#01ac8c',
  };

  const handleSelection = (id) => {
    let selectIds = [...selectedIdsArray];
    if (typeof id === 'boolean') {
      setState((prevState) => ({
        ...prevState,
        isSelectAll: id,
      }));
      if (!id) selectIds = [];
      else selectIds = indicatorListData.map((ele) => ele._id);
    } else if (id) {
      const itemIndex = selectIds.findIndex((val) => val === id);
      if (itemIndex >= 0) selectIds.splice(itemIndex, 1);
      else selectIds.push(id);
      if (selectIds.length !== indicatorListData.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: false,
        }));
      } else if (selectIds.length === indicatorListData.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: true,
        }));
      }
    }
    setState((prevState) => ({
      ...prevState,
      selectedIdsArray: selectIds,
    }));
    dispatch(todoAction.setSelectedIds(selectIds));
  };
  useEffect(() => {
    dispatch(todoAction.setSelectedIds(selectedIdsArray));
  }, [selectedIdsArray]);

  const renderProgressName = (progressNames, data) => {
    return progressNames?.map((item) => {
      const name = item.name || item?.name || item?.moduleName;
      const id = item.id || item?.moduleName;
      const colour = data.trafficColorDetails[id] ? data.trafficColorDetails[id] : 'grey';
      const bColour = colourCode[colour];

      return name ? (
        <span key={id} className="upper-span m-1 px-2">
          <span className="status-rounded" style={{ backgroundColor: bColour }} />
          {name}
        </span>
      ) : null;
    });
  };

  const getProgressName = (data) => {
    let nameArray;
    if (customModuleRight) {
      if (data?.measurements?.length > 0) {
        nameArray = [...progressName, ...(data?.CustomLibrary || [])];
      } else {
        nameArray = [...staticprogressName, ...(data?.CustomLibrary || [])];
      }
    } else if (data?.measurements?.length > 0) {
      nameArray = progressName;
    } else {
      nameArray = staticprogressName;
    }

    if (TestingRight) {
      nameArray = [...nameArray, ...(data?.testing || [])];
    }
    return renderProgressName(nameArray, data);
  };

  return (
    <table id="progressList" className="table custom-table layout-fixed font-13 text-center todo-fixed-col-table fixed-col-table-progress">
      <thead>
        <tr>
          <th className="w-80px w-xs-40px">
            <div className="checkbox-label no-label margin-auto">
              <input
                type="checkbox"
                onChange={(e) => handleSelection(e.target.checked)}
                name="check_all_samples"
                id="check_all_samples"
                checked={isSelectAll}
                disabled={!indicatorListData.length}
              />
              <label htmlFor="check_all_samples" className="chklabel">
                <span />
              </label>
            </div>
          </th>
          <th className="w-80px" />
          <th className="last-fix-col w-150px" onClick={() => onSortColumn('number')}>
            {headerSortingIcon(t('PROGRESS_INDICATOR.PRODUCT_REF'), t('PROGRESS_INDICATOR.NUMBER'))}
          </th>
          {selectedColumn.map((da) => (
            <th key={da} className={da.label === 'Product Description' ? 'w-150px' : 'w-100px'} onClick={() => onSortColumn(da.display)}>
              {headerSortingIcon(da.label, da.display)}
            </th>
          ))}

          <th className="w-1000px">{t('PROGRESS_INDICATOR.PRODUCT_PROGRESS')}</th>
        </tr>
      </thead>
      <tbody>
        {checkArray(indicatorList) &&
          indicatorList.map((data, idx) => (
            <tr key={data?._id}>
              <td>
                <div className="checkbox-label no-label margin-auto">
                  <input
                    onChange={() => {
                      handleSelection(data?._id);
                    }}
                    name={`checks_${idx}`}
                    id={`checks_${idx}`}
                    type="checkbox"
                    checked={selectedIdsArray.filter((val) => val === data?._id).length > 0}
                  />
                  <label htmlFor={`checks_${idx}`} className="chklabel">
                    <span />
                  </label>
                </div>
              </td>
              <td>
                <div className="image-detail hover-right">
                  <figure className="d-inline-block m-0" onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()}>
                    <div className="img-preview-inside-table sm">
                      <img width="60" alt="product img" src={data?.image || noImage} />
                    </div>
                  </figure>
                </div>
              </td>
              <td className="last-fix-col">
                {data?.number}
                {moduleAccess?.productsAccess && (
                  <Link 
                    className="cursor-pointer text-dark text-decoration-none" 
                    to={productLandingPath(data?._id)} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <i className="icon-detail_page pl-1 text-dark" />
                  </Link>
                )}
              </td>
              {selectedColumn.map((da) => {
                return (
                  <td key={da.display} className="w-50px">
                    {shortenStringWithTooltip(data[da.display], 30) || '--'}
                  </td>
                );
              })}
              <td>
                {getProgressName(data)}

                <span>
                  <Progress completed={parseFloat(data.percentage)} />
                  <span className="percentage">{data.percentage} %</span>
                </span>
              </td>
            </tr>
          ))}

        {loading && (
          <tr>
            <td colSpan={(selectedColumn?.length || 0) + 4}>
              <Loader />
            </td>
          </tr>
        )}

        {isEmpty(indicatorList) && !loading && (
          <tr>
            <td colSpan={(selectedColumn?.length || 0) + 4}>
              <span className="d-flex align-items-center justify-content-center">{t('PROGRESS_INDICATOR.NO_PRODUCT')}</span>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default List;
